module.exports = __webpack_public_path__ + "img/reuse.90cf4b9a.png";